import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { buildFullOptions, type DataViewOptions } from '@adornis/data-view/client/data-view-options.js';
import { XDataView } from '@adornis/data-view/client/x-data-view.js';
import type { FilterEditorOptions } from '@adornis/filter/filter-options.js';
import '@chancenwerk/design/components/cr-loader.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-data-view
 */
@customElement('cr-data-view')
export class CrDataView<T extends typeof AdornisEntity> extends XDataView<T> {}

export function buildChancenDataViewOptions<T extends typeof AdornisEntity>(
  dataViewOptions: DataViewOptions<T>,
  filterOptions?: Omit<FilterEditorOptions<T>, 'class' | 'filter'>,
) {
  return buildFullOptions(
    {
      ...dataViewOptions,
      emptyState: () => html`
        <cr-flex margin="xl" ${css({ gridColumn: `span 4` })}>
          <cr-h3 ${css({ whiteSpace: 'nowrap' })}> Keine Daten vorhanden! </cr-h3>
        </cr-flex>
      `,
      isColumnSelectable: dataViewOptions.isColumnSelectable
        ? html` <cr-flex
            ${css({
              background: DesignSystem.currentTheme.getValue().colors.secondary,
              color: 'white',
              fontSize: '1.8rem',
              cursor: 'pointer',
            })}
          >
            <cr-icon>add</cr-icon>
          </cr-flex>`
        : false,
    },
    {
      ...filterOptions,
      searchable: false,
    },
  );
}
